<template>
  <div class="h3 mb-4">Информация о туристах</div>
  <div class="paragraph-m text-secondary mb-10">
    Укажите минимальный возраст заезда, а так же определите возрастные группы детей, чтобы настроить варианты
    размещения. Диапазон включает нижнюю границу и не включает верхнюю. Например настройки диапазона: 3-7 включает в
    себя гостей, чей возраст 3 года, 4 года, 5 лет и 6 лет.
  </div>

  <tourists-types-form v-model="data" ref="formRef" />

  <div class="d-flex justify-space-between mt-10">
    <e-btn prepend-icon-src="arrowLeft" variant="secondary" @click="back">Назад</e-btn>
    <e-btn prepend-icon-src="arrowRight" :loading="isLoading" variant="primary" @click="next">Далее</e-btn>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import type { PVMTouristsInfo } from '@/parts/tariffs/types/tariffs';
import { EBtn } from '@/core/components/ui';
import TouristsTypesForm from '@/parts/tariffs/components/TouristsTypesForm.vue';

defineProps<{
  isLoading: boolean;
}>();

const emit = defineEmits<{
  (event: 'back'): void;
  (event: 'next'): void;
}>();

const back = () => {
  emit('back');
};

const formRef = ref();

const data = defineModel<PVMTouristsInfo>({ required: true });

watch(
  () => data.value.touristTypes,
  () => {
    data.value.touristTypes.forEach((type, index) => {
      if (index === 0) {
        return;
      }

      const prevAge = data.value.touristTypes[index - 1].to;

      type.from = +prevAge!;
    });
  },
  {
    deep: true,
  },
);

const next = async () => {
  const valid = await formRef.value?.validate();

  if (!valid) {
    return;
  }

  emit('next');
};
</script>

<style scoped lang="scss"></style>
